import React from "react";
import Grid from "@material-ui/core/Grid";
import NewBookPreview from "../../img/new-book-preview.png";
import {Colors} from "../../theme/colors";
import styled from "styled-components";
import {CustomDiamondIcon} from "../ui-base/icons/cutom-diamond-icon";

export const BookCover: React.FC<Props> = ({title, description, author, showDiamondIcon = false, isMarket = false, clickAction}) => {
    return (
        <>
            <StyledBookCoverContainer item style={{position: 'relative'}}>
                <StyledImg src={NewBookPreview} onClick={() => {
                    if (clickAction) {
                        clickAction();
                    }
                }} style={{cursor: (!isMarket) ? 'pointer' : 'default'}}/>

                <StyledBookTitleContainer container direction={"column"} justifyContent="space-between" onClick={() => {
                    if (clickAction) {
                        clickAction();
                    }
                }}>
                    <Grid item style={{maxWidth: '100%'}}>
                        <StyledBookTitle>{title}</StyledBookTitle>
                        <StyledBookDesc>{description || ''}</StyledBookDesc>
                    </Grid>
                    <Grid item style={{maxWidth: '100%'}}>
                        <StyledBookAuthor>{author || ''}</StyledBookAuthor>
                    </Grid>
                </StyledBookTitleContainer>

                {showDiamondIcon &&
                    <StyledBookMarketContainer>
                        <CustomDiamondIcon style={{height: '25px', width: '25px', stroke: Colors.yellow, fill: 'transparent'}}/>
                    </StyledBookMarketContainer>
                }
            </StyledBookCoverContainer>
        </>
    )
}

const StyledBookCoverContainer = styled(Grid)`
  position: relative;
`;

const StyledImg = styled('img')`
  width: 218px;
  -webkit-box-shadow: -11px 0px 50px -34px ${Colors.neutral30};
  -moz-box-shadow: -11px 0px 50px -34px ${Colors.neutral30};
  box-shadow: -11px 0px 50px -34px ${Colors.neutral30};
`;

const StyledBookTitleContainer = styled(Grid)`
  position: absolute;
  top: 35px;
  left: 20px;
  width: 190px;
  height: 280px;
  word-wrap: break-word;
  overflow: hidden;
`;

const StyledBookTitle = styled('h6')`
  color: ${Colors.neutral20};
  font-weight: 800;
  font-size: 1.5rem;
  line-height: 110%;
  text-transform: uppercase;
  max-height: 55px;
  overflow: hidden;
`;

const StyledBookDesc = styled('p')`
  margin-top: 5px;
  color: ${Colors.neutral20};
  font-weight: 500;
  font-size: 0.4rem;
  line-height: 144%;
  height: 47px;
  overflow: hidden;
`;

const StyledBookAuthor = styled('p')`
  color: ${Colors.neutral20};
  font-weight: 500;
  font-size: 0.4rem;
  line-height: 144%;
  text-align: center;
`;

const StyledBookMarketContainer = styled(Grid)`
  position: absolute;
  top: 10px;
  right: 10px;
`;

interface Props {
    title: string,
    description: string,
    author: string,
    isMarket?: boolean,
    showDiamondIcon?: boolean,
    clickAction?: () => void,
}